import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bank-icon',
  templateUrl: './bank-icon.component.html',
  styles: []
})
export class BankIconComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
